import { DefectItem } from "../../types/DefectItem";
import { GradingAreaMapping } from "../../config/GradingAreaMapping";
import styles from "./DefectItemCard.module.css";
import { Card, Button } from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import InspectionElement from "../../types/InspectionElement";
import AssignImagesModal from "../AssignImagesModal";
import { DefectImage } from "../../types/DefectImage";

interface Props {
    defect: DefectItem;
    defectsElement?: InspectionElement;
    assignImagesToDefect?: (defect: DefectItem, selectedImages: DefectImage[]) => void;
}

export default function DefectItemCard({ defect, defectsElement, assignImagesToDefect }: Props) {
    const { t } = useTranslation("common");
    const [showAssignImagesModal, setShowAssignImagesModal] = useState(false);
    
    const gradingAreaName = GradingAreaMapping[defect.gradingArea] || defect.gradingArea;
    
    const getAssignedImagesCount = () => {
        if (defect.images) {
            try {
                const parsedImages = JSON.parse(defect.images);
                if (Array.isArray(parsedImages)) {
                    return parsedImages.length;
                }
            } catch (error) {
                console.warn("Failed to parse defect images:", error);
            }
        }
        return 0;
    };

    const assignedImagesCount = getAssignedImagesCount();
    
    const handleAssignImages = () => {
        setShowAssignImagesModal(true);
    };

    return (
        <>
            <AssignImagesModal
                active={showAssignImagesModal}
                closeModal={() => setShowAssignImagesModal(false)}
                defect={defect}
                defectsElement={defectsElement}
                assignImagesToDefect={assignImagesToDefect}
            />
            
            <Card>
                <div className={styles.cardHeader} style={{ padding: '16px' }}>
                    <div className={styles.name}>
                        {defect.shortGenName && (
                            <div className={styles.heading}>
                                {t("defects.item.title")}: {defect.shortGenName}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.infoRow}>
                    <div className={styles.infoLeft}>
                        <div className={styles.gradingArea}>
                            <strong>Grading Area:</strong>
                            <span className={styles.gradingAreaName}>{gradingAreaName}</span>
                        </div>
                        <div className={styles.description}>
                            <strong>Description:</strong> {defect.description || 'No description available'}
                        </div>
                    </div>
                    <div className={styles.infoActions}>
                        <Button
                            onClick={handleAssignImages}
                            size="large"
                        >
                            {t("defects.item.assignImages", "Assign images")}
                        </Button>
                        {assignedImagesCount > 0 && (
                            <div className={styles.imageCount}>
                                {assignedImagesCount} image{assignedImagesCount !== 1 ? 's' : ''} assigned
                            </div>
                        )}
                    </div>
                </div>
            </Card>
        </>
    );
}
